import { IAddress, IBankAccountCredentials } from '@commenda/types';
import { fetcher } from '@commenda/utils';
import { BankAccountType, Country } from '@prisma/client';

interface CreateBankAccountProps {
  bankName?: string;
  accountHolderName?: string;
  country?: Country;
  currency?: string;
  credentials?: Partial<IBankAccountCredentials>;

  accountNumber?: string;
  routingNumber?: string;

  corporationId: number;

  authorizationId?: string;
  taxRegistrationId?: string;

  subType?: string;
  officialName?: string;

  address?: IAddress;

  workRequestId?: string;
  bankAccountType?: BankAccountType;
  swiftCode?: string;
  bankAddress?: string;
  isRemittanceAccount?: boolean;
  serviceRequestTaskId?: number;
}

export async function createBankAccount(
  data: CreateBankAccountProps,
  token?: string | undefined
): Promise<{
  success: boolean;
  data: {
    bankAccount: {
      id: string;
    };
  };
}> {
  const res = await fetcher(
    'bankAccount',
    {
      method: 'POST',
      body: data,
    },
    token
  );

  const responseData = await res.json();

  return {
    success: res.ok,
    data: responseData,
  };
}
